'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';

import counter from '../counter/counter.component';
import numberFilters from '../../components/filters/number';

export class CounterDashboardController {

  addWindow: Function;

  data;
  model;

  counterOptions;
  counterSelected;
  counterGrid;

  /*@ngInject*/
  constructor($scope, $rootScope, Storage, WindowService, $q, AlertMessageFactory) {
    this.Storage   = Storage;
    this.scope     = $scope;
    this.Promise   = $q.defer;

    this.addWindow = WindowService.addItem;

    this.error     = AlertMessageFactory.error;
    this.success   = AlertMessageFactory.success;

    $rootScope.$on('storage.save.counter', (counter) => this.updateCounters());

    this.scope.counterForm = this.counterForm.bind(this);
  }

  $onInit() {

    this.Storage.onUpdate('counter', (counter, event) => {
      this.updateCounters();
    });

    this.data.onCategoryChange = () => this.updateCounters();

    this.counterOptions = {
      primaryKey: '_id',
      enableCellEdit: true,
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      noUnselect: true,
      rowEditWaitInterval: -1,
      data: [],
      onRegisterApi: (gridApi) => {
        this.counterGrid = gridApi;

        this.counterGrid.selection.on.rowSelectionChanged(this.scope, (row) => {
          this.counterSelected = undefined;

          if(row.isSelected){
            this.counterSelected = row.entity;
          }
        });
        
        this.counterGrid.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
          
          if(oldValue  == newValue) {
            return false;
          }

          return this.Storage.saveCounter(rowEntity)
            .then(() => {
              this.counterGrid.rowEdit.setRowsClean([rowEntity]);
              this.updateCounters();
            });
        });
      },
      columnDefs: [{
        displayName: '#',
        field: '_id',
        visible: false,
        width: 50
      }, {
        displayName: 'Номер',
        field: 'number',
        width: 100,
        cellEditableCondition: () => false
      }, {
        displayName: 'HEX',
        field: 'number',
        width: 100,
        cellFilter: 'hexDigit',
        cellEditableCondition: () => false
      }, {
        displayName: 'Комментарий',
        field: 'comment',
      }]
    };

    return this.Storage.loadCounters()
      .then(() => this.updateCounters());
  }

  buildCategorOptions(categories) {
    return categories.map(c => {
      var pad = '';
      for(var i = 0; i < c.realLelev; i++){
        pad += String.fromCharCode(160) + String.fromCharCode(160);
      }

      return {
        id: c._id,
        name: pad + c.name
      };
    });
  }

  updateCounters() {
    while(this.counterOptions.data.length > 0){
      this.counterOptions.data.shift();
    }

    this.Storage.getCounters()
      .filter(counter => (this.data.categorySelected ? this.data.categorySelected._id : undefined) == counter.categoryId)
      .forEach(counter => this.counterOptions.data.push(counter));

    if(this.data.categorySelected){
      this.counterOptions.data.push({
        categoryId: this.data.categorySelected._id,
        comment: ""
      });
    }
  }

  counterForm(counter) {
    this.addWindow({
      id: 'create-counter-window',
      component: 'counter',
      title: 'Форма редактирования',
      width: 700,
      height: 530,
      counter: counter,
      category: this.data.categorySelected,
      module: this.data.module,
    });
  }
}



export default angular.module('storageApp.counter-dashboard', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    counter,
    numberFilters,
  ])
  .component('counterDashboard', {
    bindings: {data: '='},
    template: require('./counter-dashboard.html'),
    transclude: true,
    controller: CounterDashboardController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/counter-dashboard/counter-dashboard.component.js